import { LinkType } from '@ria-client/segment/enums';
import type { MarketplaceEntityForProductCardType as MarketplaceEntity } from '@ria-client/supergraph/structuredContent/hydration/MarketplaceProductCard/types';
import { RatingSummary, TrackedLink } from '@ria-client/tw-shared-ui';

export interface HeaderProps {
  marketplaceEntity: MarketplaceEntity;
}

export function Header({ marketplaceEntity }: HeaderProps) {
  const {
    cta,
    displayName,
    id,
    institution,
    monetizable,
    product,
    productType,
    reviewLink,
    starRating,
    starRatingTooltip,
  } = marketplaceEntity;

  return (
    <div className="text-center sm:text-left">
      <TrackedLink
        analyticsPayload={{
          index: 0,
          institutionId: institution.id,
          offerId: id,
          productId: product.id,
          productType,
        }}
        cta={cta}
        linkType={LinkType.PRODUCT_NAME}
        monetizable={monetizable}
      >
        <h3 className="typography-body-large-bold hover:underline">{displayName}</h3>
      </TrackedLink>
      {/* Legacy Header rating row: justify center on mobile, normal from sm (768px);
          mb spacing(3)=1rem on mobile dropping to 0 at md (1080px). mt-2≈title spacing(2). */}
      <div className="mt-2 mb-4 flex justify-center sm:justify-normal md:mb-0">
        <RatingSummary
          layout="horizontal"
          reviewLink={reviewLink}
          starRating={starRating}
          starRatingTooltip={starRatingTooltip}
        />
      </div>
    </div>
  );
}
